import { __assign, __extends } from "tslib";
import React from 'react';
import { connect } from "react-redux";
import * as Actions from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { PnmacMediaQuery, PnmacPaper, PnmacRowHeader, PnmacParagraph, PnmacMeta } from 'pnmac-universal-components';
import { View } from 'react-native';
import styles from '../../styles/styles.js';
import { textStyle } from "../../v2/theme";
var Loans = /** @class */function (_super) {
  __extends(Loans, _super);
  function Loans() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Loans.prototype.render = function () {
    var _a = this.props,
      layout = _a.layout,
      translations = _a.translations;
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a, _b, _c, _d;
      return /*#__PURE__*/React.createElement(View, {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: "Loans"
      }), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacRowHeader, {
        rowHeaderContainerStyles: styles.accountSettings.titleContainer,
        item: translations.YourLoans
      }), /*#__PURE__*/React.createElement(PnmacPaper, {
        containerStyles: {
          backgroundColor: "#FFF",
          padding: 25,
          marginBottom: 20,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          borderBottom: "1px solid #e9e9e9",
          boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
          elevation: 1
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          maxWidth: 400
        }
      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: {
          fontWeight: "700",
          fontSize: 16
        }
      }, translations.Loan, " ", translations.Number)), /*#__PURE__*/React.createElement(View, {
        style: {
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: {
          fontWeight: "700",
          fontSize: 16
        }
      }, translations.Property, " ", translations.Address))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          marginLeft: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: {
          fontSize: 16
        }
      }, layout.selectedLoanNumber), /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: {
          marginTop: 10,
          fontSize: 16
        }
      }, "".concat((_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.propertyAddressLine1)), /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: {
          marginTop: 10,
          fontSize: 16
        }
      }, "".concat((_b = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _b === void 0 ? void 0 : _b.propertyLocality, " ").concat((_c = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _c === void 0 ? void 0 : _c.propertyRegion, ", ").concat((_d = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _d === void 0 ? void 0 : _d.propertyPostalCode))))))));
    });
  };
  return Loans;
}(React.Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(Loans);